import api from '@/service/api';
import variables from "@/service/variables";
export default class EFormService {
     
    
    CheckAD(AD) {
        return api.get(variables.API_URL + '/api/EForm/CheckAD/' + AD)
    } 
    CheckADArray(AD) {
        return api.get(variables.API_URL + '/api/EForm/CheckADArray/' + AD)
    }
    CheckADByBG(AD,BG) {
        return api.get(variables.API_URL + '/api/EForm/CheckADByBG/' + AD+'/'+BG)
    } 
    CheckADArrayByBG(AD,BG) {
        return api.get(variables.API_URL + '/api/EForm/CheckADArrayByBG/'  + AD+'/'+BG )
    }
}